import { FuturesMarketKey } from '@kwenta/sdk/types'
import { useRouter } from 'next/router'
import { useCallback } from 'react'
import styled from 'styled-components'

import { TransactionPencilButton, PencilButtonProps } from 'components/Button/PencilButton'
import ROUTES from 'constants/routes'
import { setShowPositionModal } from 'state/app/reducer'
import { FuturesPositionModalType } from 'state/app/types'
import { editPositionSize } from 'state/futures/actions'
import { PerpsProvider } from 'state/futures/types'
import { useAppDispatch } from 'state/hooks'

export default function EditPositionButton({
	marketKey,
	modalType,
	...props
}: PencilButtonProps & {
	marketKey: FuturesMarketKey
	modalType: FuturesPositionModalType
}) {
	const dispatch = useAppDispatch()
	const router = useRouter()
	const onClick = useCallback(() => {
		dispatch(
			setShowPositionModal({
				type: modalType,
				marketKey: marketKey,
			})
		)
		dispatch(editPositionSize(marketKey, '0'))
		if (!router.pathname.includes('market')) {
			router.push(ROUTES.Markets.Home(PerpsProvider.SNX_V3))
		}
	}, [dispatch, marketKey, modalType, router])
	return (
		<Container>
			<TransactionPencilButton width={12} height={12} onClick={onClick} {...props} />
		</Container>
	)
}

const Container = styled.button`
	border: 0;
	background: none;
	padding: 0;
`
